
export const CHECKOUT_URL =
  'https://tejer.impultienda.ar/checkout/tejer'

export const PIXEL_ID = '1591693235820229'

export const MOCKUP_IMAGE =
  'https://cdn.magicpatterns.com/uploads/qSBbAoibGHd84pwtcUXF6u/MOCKUP_PRINCIPAL_TEJER_sin_fondo.png'

export const BONO_IMAGES = {
  bono1: 'https://cdn.magicpatterns.com/uploads/cE3gewZRDERJNMDiRq5XDr/BONO_1_TEJER.png',
  bono2: 'https://cdn.magicpatterns.com/uploads/ehSEvM1eBAWBMXEDYrGorE/BONO_2_TEJER.png',
  bono3: 'https://cdn.magicpatterns.com/uploads/3CYVwN4khuFcNDTj57QWjs/BONO_3_TEJER.png',
  bono4: 'https://cdn.magicpatterns.com/uploads/fSupudbda4SjSDfgCZaebj/BONO_4_TEJER.png',
}

type PixelEvent = 'PageView' | 'InitiateCheckout'

type PixelWindow = Window & {
  fbq?: (action: 'track', event: PixelEvent) => void
}

/**
 * Uses Meta's 1×1 tracking endpoint rather than injecting a third-party script.
 * This keeps the landing page stable when a browser, iframe, or ad blocker blocks
 * fbevents.js while preserving the requested PageView and checkout signals.
 */
export function trackPixelEvent(event: PixelEvent) {
  if (typeof document === 'undefined') return

  const pixelWindow = window as PixelWindow
  if (typeof pixelWindow.fbq === 'function') {
    pixelWindow.fbq('track', event)
    return
  }

  const beacon = new Image(1, 1)
  beacon.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=${event}&noscript=1`
}

export function goToCheckout() {
  trackPixelEvent('InitiateCheckout')
  window.location.assign(CHECKOUT_URL)
}
